"use strict";
exports.__esModule = true;
exports.c_table_m_compact_cell_PaddingBottom = {
  "name": "--pf-v5-c-table--m-compact--cell--PaddingBottom",
  "value": "0.5rem",
  "var": "var(--pf-v5-c-table--m-compact--cell--PaddingBottom)"
};
exports["default"] = exports.c_table_m_compact_cell_PaddingBottom;